import styled from 'styled-components';

import { COLORS, STATUS_COLORS } from '../../../../theme/tokens';
import { Text } from '../../../../components/Text/Text';

export const Copy = styled(Text)`
  display: block;
  font-size: 14px;
  line-height: 1.5;
  color: ${COLORS.textMuted};
  margin-bottom: 12px;
`;

export const BriefArea = styled.textarea`
  width: 100%;
  box-sizing: border-box;
  min-height: 132px;
  resize: vertical;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1px solid ${COLORS.panelBorder};
  background: ${COLORS.surfaceInset};
  color: ${COLORS.text};
  font-family: inherit;
  font-size: 14px;
  line-height: 1.6;
  outline: none;

  &:focus {
    border-color: ${COLORS.ctaBorder};
  }

  &::placeholder {
    color: ${COLORS.textFaint};
  }
`;

/**
 * Says how much more is needed while the brief is too short, and gets out of the
 * way once it is long enough. A disabled button with no explanation is the thing
 * this exists to prevent.
 */
export const Hint = styled(Text)<{ $short: boolean }>`
  display: block;
  margin-top: 8px;
  font-size: 12px;
  line-height: 1.5;
  color: ${(p) => (p.$short ? COLORS.textFaint : STATUS_COLORS.positive)};
`;
